import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setter, getter } from '@stencil/client-side-storage';
import {
  fareSelector,
  offersSelector,
  reviewSelectedSelector,
  promoDetailsSelector,
  gocashSelector,
  travellerDetailsSelector,
  loaderSelector,
  isLoggedInSelector,
  exactLocationApplicableSelector,
  paymentSelector,
  preAppliedPromoSelector,
  specialInfoSelector,
  dispatchSearchIdSelector,
  reviewResultsSelector,
  displayGstinSelector,
  sourceAsGstinSelector
} from "../../redux/selector";
import PaymentComponent from "../../../../../stories/components/cars/reviewpage/PaymentComponent/PaymentComponentUI";
import { fetchBlockApi, fetchPriceResults } from "../../redux/thunks";
import OffersComponent from "../../../../../stories/components/cars/reviewpage/OffersComponent/OffersComponentUI";
import { formValidator, scrollToTop, getAbsValue } from "../../../../config/utils";
import ConsentPopup from "../../../../../stories/components/cars/reviewpage/Consentpopup/Consentpopup";

import GoCashComp from "../GoCashComp/GoCashComp";
import { CTA_TYPE, getActionNameForOmniture, pushOmniEvents } from "../../../../../shared/utils/omni-utils";
import { vehicledataSelector } from "../../../SearchPage/redux/selector";
import dateFormat from 'dateformat'
import { hrPackageSelector, tripTypeSelector } from "../../../../../shared/common/redux/selector";
import { GoTribeSideStrip } from '@growth/gotribe/goTribeSideStrip';
import { gcBookingReviewScreen, getCtaProperty, getRouteDetails, getTripDays, pushCtaOmniEvents, sendEventOnError } from "../../../../../shared/config/omni";
import { APPLY_GO_CASH, CABS_REVIEW_PAGE, CABS_REVIEW_ROUTE, dateTypeFormat, DYNAMIC_ERROR, GO_TRIBE_STRIP_CARD_NOT_SHOWN, GO_TRIBE_STRIP_CARD_SHOWN, LOBNAME, MOB_CABS_REVIEW, PAY, PAYMENT_OFFERS, PAYMENT_PAGE_ROUTE, REMOVED_GO_CASH, ROUND_TRIP, RouteCountry, timeTypeFormat } from "../../../../../shared/utils/util-constants";
import styled from 'styled-components';

const GoTribeSideStripCont = styled.div`
  marginTop: 2rem;

  h5 {
    color: inherit !important;
  }
`

const PaymentOffers = (props) => {
  const dispatch = useDispatch();
  const [showContentpopup, setContentpopup] = useState(false);
  const fareDetails = useSelector(fareSelector);
  const paymentOptions = useSelector(paymentSelector);
  const offers = useSelector(offersSelector);
  const reviewSelectedData = useSelector(reviewSelectedSelector);
  const isLoggedIn = useSelector(isLoggedInSelector);
  const promoDetails = useSelector(promoDetailsSelector);
  const gocashData = useSelector(gocashSelector);
  const travellerDetails = useSelector(travellerDetailsSelector);
  const reviewResults = useSelector(reviewResultsSelector)
  const vehicle_data = useSelector(vehicledataSelector);
  const pc = useSelector(preAppliedPromoSelector);
  const { isBlockapi } = useSelector(loaderSelector);
  const specialInfo = useSelector(specialInfoSelector);
  const dispatchSearchId = useSelector(dispatchSearchIdSelector);
  const { isPayCount = 0, apply_gocash = false, isConsentAvailable = false } = reviewSelectedData;
  const exactLocationApplicable = useSelector(exactLocationApplicableSelector);
  const tripType = useSelector(tripTypeSelector)
  const hrSelectedPackageId : string = useSelector(hrPackageSelector)
  const displayGstin = useSelector(displayGstinSelector)
  const sourceAsGstin = useSelector(sourceAsGstinSelector)

  const sendEventOnPaymentClick = () => {
    const { booking_tags = []} = reviewResults;
    let bookingTags = ""
    const skuDetails = `${reviewResults?.category} | ${reviewResults?.t} ${reviewResults?.st} | fuelType : ${reviewResults?.fuel?.t || ""}`
    if (booking_tags?.length) {
      booking_tags.forEach(tag => {
        bookingTags += bookingTags.length ? `| ${tag}` : `${tag} `
      })
    }
    const eventDetails = {
      cta: getCtaProperty(getActionNameForOmniture(gcBookingReviewScreen, PAY), CTA_TYPE.BUTTON, PAYMENT_OFFERS, PAYMENT_PAGE_ROUTE),
      productListItems: [
        {
          SKU: skuDetails
        }
      ],
      booking: {
        tripType: tripType?.rf === 'hr' ? tripType?.name : reviewResults?.trip_type,
        routeCity: tripType?.rf === 'hr' ? getRouteDetails(reviewResults?.source_city, '') : getRouteDetails(reviewResults?.source_city, reviewResults?.destination_city),
        routeState: tripType?.rf === 'hr' ? getRouteDetails(reviewResults?.source_state, '') : getRouteDetails(reviewResults?.source_state, reviewResults?.destination_state),
        routeCountry: RouteCountry,
        departureDate: `${dateFormat(reviewResults?.start_time, dateTypeFormat)}`,
        departureTime: `${dateFormat(reviewResults?.start_time, timeTypeFormat)}`,
        cabsIsPrivateAvailable: vehicle_data?.length ? "yes" : "no",
        promocode: Object.keys(promoDetails)?.length && promoDetails?.Message && promoDetails?.Code !== pc ? '' : reviewSelectedData?.promocode,
        offerId: Object.keys(promoDetails)?.length && promoDetails?.Message && promoDetails?.Code !== pc ? '' : reviewSelectedData?.promocode,
        bookingTags: bookingTags,
        daysToTrip: getTripDays(new Date().toString(), reviewResults?.start_time)
      }
    }

    if (tripType?.rf === 'hr') {
      eventDetails.booking["packageId"] = hrSelectedPackageId
    }

    if (reviewResults?.trip_type === ROUND_TRIP) {
      eventDetails.booking["returnDate"]  = `${dateFormat(reviewResults?.end_time, dateTypeFormat)}`
      eventDetails.booking["returnTime"]  = `${dateFormat(reviewResults?.end_time, timeTypeFormat)}`
      eventDetails.booking["duration"]    = getTripDays(reviewResults?.start_time, reviewResults?.end_time)
    }

    pushOmniEvents({eventName: "payAndConfirm", details : eventDetails})
  }

  const callPayment = useCallback(() => {
    const { first_name = "", phone_number = "", email = "", gender = "" } = travellerDetails;
    if (first_name || email || phone_number || gender) {
      const isNameValid = formValidator({
        type: "first_name",
        value: first_name,
      });
      const isEmailValid = formValidator({ type: "email", value: email });
      const isMobileValid = formValidator({ type: "phone_number", value: phone_number });
      if(!isNameValid || !isEmailValid || !isMobileValid){
        onTravellerErrorUpdate({
          first_name: { error: !isNameValid },
          phone_number: { error: !isMobileValid },
          email: { error: !isEmailValid }
        });
      } 
      if (
        !!isNameValid &&
        !!isEmailValid &&
        !!isMobileValid &&
        gender?.length &&
        !exactLocationApplicable
      ) {
        if (!isConsentAvailable && Object.keys(specialInfo)?.length) {
          setContentpopup(true);
          return;
        }

        if (displayGstin && sourceAsGstin) {
          dispatch(fetchBlockApi({state : reviewResults?.source_state}));
        } else {
          props?.billingDetailsRef?.current?.onSave()
        }
        
        sendEventOnPaymentClick()
      } else {
        const isNum = exactLocationApplicable ? 1100 : 1700;
        scrollToTop(isNum);
      }
      return;
    } else if (!first_name && !email && !phone_number) {
      onTravellerErrorUpdate({
        first_name: { error: true },
        phone_number: { error: true },
        email: { error: true }
      });
      scrollToTop(1100);
  
      return;
    }
  }, [dispatch, isBlockapi, travellerDetails, isConsentAvailable, sourceAsGstin]);

  const onConsentPopClick = (flag) => {
    setContentpopup(false);
    if (flag) {
      dispatch({
        type: "UPDATE_REVIEW_SELECTED_DATA",
        reviewSelectedData: { isConsentAvailable: true }
      });
      if (displayGstin && sourceAsGstin) {
        dispatch(fetchBlockApi({state : reviewResults?.source_state}));
      } else {
        props?.billingDetailsRef?.current?.onSave()
      }
      sendEventOnPaymentClick()
      setter('isConsentAvailable', dispatchSearchId);
    }
  };
  useEffect(() => {
    const searchId = getter('isConsentAvailable');
    if (searchId === dispatchSearchId) {
      dispatch({
        type: "UPDATE_REVIEW_SELECTED_DATA",
        reviewSelectedData: { isConsentAvailable: true }
      });
    }
  }, []);

  useEffect(() => {
    const { Full = {}, Partial = {} } = paymentOptions;
    if (Full?.is_selected) {
      updateSelectedData({ is_part_payment: false });
    } else if (Partial?.is_selected) {
      updateSelectedData({ is_part_payment: true });
    }
  }, [paymentOptions]);

  useEffect(() => {
    if (Object.keys(promoDetails)?.length && promoDetails?.Message && promoDetails?.Code !== pc && !promoDetails?.Applied) {
      pushCtaOmniEvents(`${MOB_CABS_REVIEW}_${DYNAMIC_ERROR}_${promoDetails?.Message}`, CTA_TYPE.HYPER_LINK, PAYMENT_OFFERS, CABS_REVIEW_ROUTE)
      sendEventOnError([{
        field: `promocode : ${promoDetails?.Code}`,
        message: promoDetails?.Message
      }])
    }
  }, [promoDetails])

  useEffect(() => {
    if (!(reviewResults?.goTribeStripData && Object.keys(reviewResults?.goTribeStripData).length)) {
      pushCtaOmniEvents(`${MOB_CABS_REVIEW}_${GO_TRIBE_STRIP_CARD_NOT_SHOWN}`, CTA_TYPE.HYPER_LINK, CABS_REVIEW_PAGE, CABS_REVIEW_ROUTE)
    }
  }, [reviewResults?.goTribeStripData]);

  const updateSelectedData = useCallback(
    (selectedData) => {
      const { promocode } = selectedData;
      dispatch({
        type: "UPDATE_REVIEW_SELECTED_DATA",
        reviewSelectedData: selectedData,
      });
      if (promocode !== undefined) {
        dispatch(fetchPriceResults());
      }
    },
    [dispatch]
  );
  const onTravellerErrorUpdate = useCallback(
    (error) => {
      dispatch({
        type: "UPDATE_TRAVELLER_ERROR",
        error,
      });
    },
    [dispatch]
  );
  const updateGocash = useCallback(() => {
    pushCtaOmniEvents(getActionNameForOmniture(gcBookingReviewScreen, apply_gocash ? REMOVED_GO_CASH : APPLY_GO_CASH), CTA_TYPE.RADIO_BUTTON, PAYMENT_OFFERS, CABS_REVIEW_ROUTE)
    dispatch({
      type: "UPDATE_REVIEW_SELECTED_DATA",
      reviewSelectedData: {
        ...reviewSelectedData,
        apply_gocash: !apply_gocash
      }
    });
    dispatch(fetchPriceResults());
  }, [dispatch]);

  const { fare_details = [], price_pers = "", tool_tip = "" } = fareDetails;
  const { Is_gocash_applicable, Order = {}, User = {}, Gocash_persuasion='' } = gocashData;
  const { Total = 0 } = Order;
  const Ototal = getAbsValue(Total);
  const { Total: Utotal = '' } = User;
  
  return (
    <>
      {showContentpopup ? (
        <ConsentPopup onConsentPopClick={onConsentPopClick} {...specialInfo} />
      ) : null}
      <PaymentComponent
        {...paymentOptions}
        {...reviewSelectedData}
        fare_details={fare_details}
        callPayment={callPayment}
        price_pers={price_pers}
        updateSelectedData={updateSelectedData}
        tool_tip={tool_tip}
        {...gocashData}
      />
      {
        isLoggedIn && Is_gocash_applicable && Utotal>0 ?
          <GoCashComp 
            totalbalance={Utotal}
            eligibleBalance={Ototal}
            info={Gocash_persuasion}
            margin="10px 0"
            apply_gocash={apply_gocash}
            applyGocashAction={updateGocash}
            {...gocashData}
          />
          : null
      }
      { reviewResults?.goTribeStripData?.data && Object.keys(reviewResults?.goTribeStripData?.data).length ? (
        <GoTribeSideStripCont>
          <GoTribeSideStrip
            lob={LOBNAME}
            heading={reviewResults?.goTribeStripData?.data?.header}
            image={reviewResults?.goTribeStripData?.data?.goCashIconUrl}
            text={reviewResults?.goTribeStripData?.data?.message}
            onLoad={() => {
              pushCtaOmniEvents(`${MOB_CABS_REVIEW}_${GO_TRIBE_STRIP_CARD_SHOWN}`, CTA_TYPE.HYPER_LINK, CABS_REVIEW_PAGE, CABS_REVIEW_ROUTE)
            }}
          />
        </GoTribeSideStripCont>
      ) : null}
      <OffersComponent
        isLoggedIn={isLoggedIn}
        offers={offers}
        promocode={reviewSelectedData?.promocode}
        updateSelectedData={updateSelectedData}
        {...promoDetails}
        {...gocashData}
        apply_gocash={apply_gocash}
        isPayCount={isPayCount}
        preAppliedPromo={pc}
      />
    </>
  );
};

export default React.memo(PaymentOffers);
